// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.snapshot-creation-tab-view__icon-play {
  color: #6fb96f;
  font-size: 16px;
}

.snapshot-creation-tab-view__icon {
  vertical-align: middle;
}

.tab-view-button-group__button.active .snapshot-creation-tab-view__icon {
  color: var(--info);
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/Graph/GraphSnapshotCreation/GraphSnapshotCreation.css","webpack://./services/frontend/app/components/Graph/GraphSnapshotCreation/GraphSnapshotCreation.css"],"names":[],"mappings":"AADA;ECEE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".snapshot-creation-tab-view__icon-play {\n  color: #6fb96f;\n  font-size: 16px;\n}\n\n.snapshot-creation-tab-view__icon {\n  vertical-align: middle;\n}\n\n.tab-view-button-group__button.active .snapshot-creation-tab-view__icon {\n  color: var(--info);\n}\n",".snapshot-creation-tab-view__icon-play {\n  color: #6fb96f;\n  font-size: 16px;\n}\n\n.snapshot-creation-tab-view__icon {\n  vertical-align: middle;\n}\n\n.tab-view-button-group__button.active .snapshot-creation-tab-view__icon {\n  color: var(--info);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
